/* eslint-disable */
import axios from 'axios';
import Vue from 'vue'
import { API_BASE_URL, API_NAME_TOKEN, APP_EMPRESA_SEL } from '../apiConfig'

export const getHeaders = function () {
  let idEmpresa = localStorage.getItem(APP_EMPRESA_SEL);
  if ( (idEmpresa == null) || (idEmpresa == "") )
    idEmpresa ="-";
  else
    idEmpresa = Buffer.from(idEmpresa).toString("base64");

  return {
    'Authorization': localStorage.getItem(API_NAME_TOKEN) + '',
    'Access-Control-Allow-Credentials': true,
    'x-empresa': idEmpresa
  }
}
export default class Resource {
  constructor(url) {
    this._url = url;
  }
  static getApiBaseUrl() {
    return API_BASE_URL;
  }

  errorResponseFilter(error) {
    //console.log(error);
    //if (error.response.status == 403) {      
    //  Vue.$sistema.$logout()
    //}
  }

  successResponseFilter(res) {
    localStorage.setItem(process.env.APP_LOCAL_TOKEN, res.headers.authorization);
  }

  delete(id) {

    return new Promise((resolve, reject) => {
      axios.delete(`${Resource.getApiBaseUrl()}/${this._url}/${id}`, {
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    });
  }

  filter(obj) {
    return new Promise((resolve, reject) => {
      axios.post(`${Resource.getApiBaseUrl()}/${this._url}/filter`, obj, {
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error) }
      );
    });
  }

  post(obj, url = 'save') {
    //console.log(obj);
    return new Promise((resolve, reject) => {
      axios.post(`${Resource.getApiBaseUrl()}/${this._url}/${url}`, obj, {
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    });
}


  getWithPath(path) {
    return new Promise((resolve, reject) => {
      axios.get(`${Resource.getApiBaseUrl()}/${this._url}/${path}`, {
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    })
  }

  getGeneric(path) {
    return new Promise((resolve, reject) => {
      axios.get(`${path}`, {
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    })
  }

  getWithPathDownload(path) {
    return new Promise((resolve, reject) => {
      axios.get(`${Resource.getApiBaseUrl()}/${this._url}/${path}`, {
        responseType: 'arraybuffer',
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    })
  }

  getWithOutPathDownload(path) {
    return new Promise((resolve, reject) => {
      axios.get(`${Resource.getApiBaseUrl()}/${path}`, {
        responseType: 'arraybuffer',
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    })
  }

  getWithOutPath(path) {
    //console.log("ouvir->",`${Resource.getApiBaseUrl()}/${path}`);
    return new Promise((resolve, reject) => {
      axios.get(`${Resource.getApiBaseUrl()}/${path}`, {
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    })
  }
  postWithOutPath(path, obj) {
    return new Promise((resolve, reject) => {
      axios.post(`${Resource.getApiBaseUrl()}/${path}`, obj, {
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    });

  }
  postWithPath(path, obj) {
    return new Promise((resolve, reject) => {
      axios.post(`${Resource.getApiBaseUrl()}/${this._url}/${path}`, obj, {
        headers: getHeaders()
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    });

  }

  postDownloadWithPath(path, obj) {
    return new Promise((resolve, reject) => {
      axios.post(`${Resource.getApiBaseUrl()}/${this._url}/${path}`, obj, {
        headers: getHeaders(),
        responseType: 'blob'
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    });

  }

  get(params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Resource.getApiBaseUrl()}/${this._url}`, {
        headers: getHeaders(),
        params
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    })
  }


  listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${Resource.getApiBaseUrl()}/${this._url}/`, {
        headers: {
          'Authorization': localStorage.getItem(process.env.APP_LOCAL_TOKEN) + ''
        },
      }).then(
        response => { this.successResponseFilter(response); resolve(response); },
        error => { this.errorResponseFilter(error); reject(error); }
      );
    })
  }
}

